import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: ${({ theme }) => theme.spacings.xlarge};
	padding: ${({ theme }) => `${theme.spacings.xlarge} ${theme.spacings.medium} ${theme.spacings.xsmall}`};
`;

export const Sections = styled.section`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.xsmall};
`;

export const SectionWrapper = styled.section`
	display: flex;
	flex-direction: column;
	width: 100%;
	row-gap: ${({ theme }) => theme.spacings.xsmall};
`;

export const SectionTitle = styled.span`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const ButtonsWrapper = styled(SectionWrapper)`
	align-items: center;
	align-self: flex-end;
	flex-shrink: 0;

	${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
		position: fixed;
		bottom: 0;
		left: 0;
		padding-left: ${({ theme }) => theme.spacings.medium};
		padding-right: ${({ theme }) => theme.spacings.medium};
		padding-bottom: ${({ theme }) => theme.spacings.small};
		padding-top: ${({ theme }) => theme.spacings.small};

		background: ${({ theme }) => theme.colors.backgrounds.main.container};
	}
`;
